import { useState } from 'react'
import { useApiClient } from '@/hooks'
import { downloadApiResponse } from '@/utils'

export type ExportType = 'external' | 'internal_with_distance'

export const EXPORT_TYPE_OPTIONS = {
  EXTERNAL: 'external' as ExportType,
  INTERNAL_WITH_DISTANCE: 'internal_with_distance' as ExportType,
}

export type HoursReportsExportParams = {
  contractor?: string
  startDate?: string
  endDate?: string
  isExported?: boolean
  exportType?: ExportType
}

export const useHoursReportsExport = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const exportReport = async ({
    contractor,
    startDate,
    endDate,
    isExported,
    exportType = EXPORT_TYPE_OPTIONS.EXTERNAL,
  }: HoursReportsExportParams) => {
    const queryParams = new URLSearchParams()

    if (contractor) queryParams.append('contractor', contractor)
    if (startDate) queryParams.append('date_start', startDate)
    if (endDate) queryParams.append('date_end', endDate)
    if (isExported !== undefined && exportType === EXPORT_TYPE_OPTIONS.EXTERNAL)
      queryParams.append('is_exported', isExported ? 'true' : 'false')

    setLoading(true)

    try {
      const endpoint =
        exportType === EXPORT_TYPE_OPTIONS.INTERNAL_WITH_DISTANCE
          ? '/hours_reporting/hr/export_with_distance/'
          : '/hours_reporting/hr/export/'

      const response = await client.get<Blob>(
        `${endpoint}?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response)
    } finally {
      setLoading(false)
    }
  }

  return { exportReport, loading }
}
